import { gql } from "@apollo/client";

// starts a rota load run - one site (single-site Load Rota) or many (the
// bulk wizard), both going through the same async, tracked run. Returns
// immediately with a batchId; it does not wait for sites to finish loading.
export const startRotaLoadMutation = gql`
mutation($input: RotaLoadStartInput!){
  startRotaLoad(input: $input) {
    response
    message
  }
}
`;

// turns off "Rolling" for one or more sites - the sites keep whatever's
// already loaded, they just stop auto-extending
export const stopRotaRollingMutation = gql`
mutation($input: StopRotaRollingInput!){
  stopRotaRolling(input: $input) {
    response
    message
  }
}
`;
